"use strict";
import "lodash";
import { svc_report } from "@/services/reports";
import { showServerResponse } from "@/utils/message";
import logger from "@/utils/logger";

const endpointBasePrefix = "reports";

const Model = {
	namespace: "m_Reports",
	state: {
	},
	reducers: {
	},
	effects: {
		*generate({ payload }, { call, put }) {
			let fileName = `${payload.startDate}-${payload.reportType}.${payload.format}`;
			if (payload.fileName) {
				fileName = payload.fileName;
			}

			let data = yield call(svc_report, payload);
			if(data.status != 200 && data.status != undefined){
				if (data.serverResponse?.text && data.status === 500) {
					data.serverResponse.text().then(r => {
						try{
							let response = JSON.parse(r);
							if(response.error === "InternalServerError")
								return showServerResponse(response);
						} catch (e) {
							return 0;
						}
					})
				}
				return 0;
			}
			let resBlob = data;
			if(payload.format == "pdf"){
				const file = new Blob(
						[resBlob],
						{
								type: 'application/pdf',
						});
				//const fileURL = URL.createObjectURL(file);
				//window.open(fileURL);
				return data;
			}else{
				const file = new Blob(
					[resBlob],
					{
						type: 'application/octet-stream',
					});
				const fileURL = URL.createObjectURL(file);

				var a = document.createElement('A');
				a.href = fileURL;
				a.target = 'file';
				a.setAttribute('download', fileName);
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			}
		}
	},
	subscriptions: {},
};

export default Model;
